/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RsrImport
 */
export interface RsrImport {
    /**
     * 
     * @type {number}
     * @memberof RsrImport
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof RsrImport
     */
    jahr: number;
    /**
     * 
     * @type {string}
     * @memberof RsrImport
     */
    uebertragenAm: string;
    /**
     * 
     * @type {number}
     * @memberof RsrImport
     */
    internalId: number;
    /**
     * 
     * @type {string}
     * @memberof RsrImport
     */
    maschinenGruppe: string;
}

/**
 * Check if a given object implements the RsrImport interface.
 */
export function instanceOfRsrImport(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "jahr" in value;
    isInstance = isInstance && "uebertragenAm" in value;
    isInstance = isInstance && "internalId" in value;
    isInstance = isInstance && "maschinenGruppe" in value;

    return isInstance;
}

export function RsrImportFromJSON(json: any): RsrImport {
    return RsrImportFromJSONTyped(json, false);
}

export function RsrImportFromJSONTyped(json: any, ignoreDiscriminator: boolean): RsrImport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'jahr': json['jahr'],
        'uebertragenAm': json['uebertragenAm'],
        'internalId': json['internalId'],
        'maschinenGruppe': json['maschinenGruppe'],
    };
}

export function RsrImportToJSON(value?: RsrImport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'jahr': value.jahr,
        'uebertragenAm': value.uebertragenAm,
        'internalId': value.internalId,
        'maschinenGruppe': value.maschinenGruppe,
    };
}

